module.exports = "https://www.gc-pro.gnp.com.mx/675be28545c5cede8d6a019a199454bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/flecha-abajo.svg
// module id = 215
// module chunks = 0